import script from "./department.vue?vue&type=script&setup=true&lang=js"
export * from "./department.vue?vue&type=script&setup=true&lang=js"

import "./department.vue?vue&type=style&index=0&id=b0f7c8ac&lang=scss"

const __exports__ = script;

export default __exports__